import { CollectionEntity } from "@busy-human/gearbox";
import { z } from "zod";
export var BuilderHealthRecord;
(function (BuilderHealthRecord) {
    BuilderHealthRecord.SectionSchema = z.object({
        fullName: z.string().default(""),
        dob: z.string().default(""),
        builderSignature: z.string().default(""),
        builderDate: z.string().datetime().default(new Date().toISOString()),
        parentSignature: z.string().optional(),
        parentDate: z.string().datetime().optional()
    });
    BuilderHealthRecord.SectionBSchema = BuilderHealthRecord.SectionSchema.extend({
        dob: z.null().default(null),
        consentForRelease: z.boolean().default(false),
        parentFullName: z.string().optional(),
        relationToPatient: z.string().optional()
    }).default({});
    BuilderHealthRecord.ModelSchema = z.object({
        season: z.string().default(""),
        "section_a": BuilderHealthRecord.SectionSchema.default({}),
        "section_b": BuilderHealthRecord.SectionSchema.default({}),
        "HIPPA_a": BuilderHealthRecord.SectionSchema.default({}),
        "HIPPA_b": BuilderHealthRecord.SectionBSchema.default({}),
        "section_c": z.object({
            doctorsName: z.string().default(""),
            doctorsEmail: z.string().email().default("")
        }).default({})
    }).default({});
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return BuilderHealthRecord.ModelSchema.parse({});
        }
    }
    BuilderHealthRecord.CollectionClass = CollectionClass;
})(BuilderHealthRecord || (BuilderHealthRecord = {}));
//# sourceMappingURL=index.js.map